import * as React from 'react'
import * as T from 'components/ui/typography'

import router from 'next/router'

import Routes from 'utils/routes'
import Button from 'components/shared/button'

import NoCreditDialog from 'components/shared/credit-dialog'

import UseCreditsCheck from 'hooks/credits/use-credits-check'
import { ChevronRight } from 'lucide-react'

interface ProposedSimCardProps {
    simulation: ExamSimulation
    testid: string
}

const ProposedSimulationCard = React.memo((props: ProposedSimCardProps) => {
    const [showZeroCreditDialog, setShowZeroCreditDialog] = React.useState<boolean>(false)

    const { simCreditsCheck } = UseCreditsCheck()

    const handleCreateSim = () => {
        if (simCreditsCheck()) {
            router.push({
                pathname: Routes.NewSimulation,
                query: {
                    simulationId: props.simulation._id,
                    category: props.simulation.category,
                },
            })
        } else setShowZeroCreditDialog(true)
    }

    return (
        <>
            <Button
                onClick={() => handleCreateSim()}
                data-testid={props.testid}
                variant="outline"
                className="px-6 py-6 flex-1 border-slate-200 rounded-lg w-full h-full h-[80px]">
                <div className="flex flex-1 items-center justify-evenly w-full">
                    <div className="text-start flex-1">
                        <T.Small>{props.simulation.name}</T.Small>
                        <T.Muted className="max-w-[280px] line-clamp-2  ">
                            {props.simulation.description || 'Simulazione'}
                        </T.Muted>
                    </div>
                    <div>
                        <ChevronRight className="text-neutral-600" />
                    </div>
                </div>
            </Button>
            <NoCreditDialog trigger={<></>} open={showZeroCreditDialog} />
        </>
    )
})

export default ProposedSimulationCard
